export const DEFAULT_SEARCH_TYPE = "opportunities"
